<template>
  <div class="modal-mask">
    <div class="modal-content-container">
      <div class="mobile-list__header-container">
        <span class="mobile-list__header-title"> Produtos </span>
        <span @click="close" class="material-icons mobile-list__closebtn-icon">
          cancel
        </span>
      </div>
      <div class="body-modal">
        <a id="download-excel" style="display:none;"></a>

        <div class="modal-actions-header">
          <div class="modal-actions-left">
            <cc-search
              v-model="search"
              placeholder="Buscar por EAN ou descrição"
              @search="onSearch"
              @keyup.enter.native="onSearch"
            />
          </div>
          <div class="modal-actions-right">
            <cc-button
              class="excel-btn"
              :content="'Exportar Excel'"
              :icon="'fa fa-file-excel'"
              :nolink="true"
              @click="export_products_report()"
            />
          </div>
        </div>

        <table class="products-table">
          <thead>
            <tr>
              <th>Código</th>
              <th>Descrição</th>
              <th>Marca</th>
              <th>Embalagem</th>
              <th>Preço Última Compra</th>
              <th>Data Última Compra</th>
              <th>Última Digitação</th>
              <th>Data Última Digitação</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(data, index) in products"
              :key="index"
              :class="getSpecialBackground(index)"
            >
              <td>{{ data.value.pro_ean }}</td>
              <td>{{ data.value.pro_descricao }}</td>
              <td>{{ data.value.marca || '--' }}</td>
              <td>{{ data.value.pro_embalagem }}</td>
              <td>
                <div v-if="data.value.pro_ultimaCompra != null">
                  {{ data.value.pro_ultimaCompra | currency }}
                </div>
                <div v-else>--</div>
              </td>
              <td>
                {{ data.value.data_ultimaCompra
                  ? getDate(data.value.data_ultimaCompra)
                  : '--'
                }}
              </td>

              <td>
                <div v-if="data.value.last_offer != null">
                  {{ data.value.last_offer | currency }}
                </div>
                <div v-else>--</div>
              </td>
              <td>
                {{ data.value.updated_at
                  ? getDate(data.value.updated_at)
                  : '--'
                }}
              </td>
            </tr>
          </tbody>

        </table>
        <cc-paginacao
            :key="'pag'"
            classes="orange"
            :items_by_page_value="50"
            :total="total"
            :page="page"
            :page_limit="11"
            v-on:change="loadPage($event)"
          ></cc-paginacao>
      </div>
    </div>

    <cc-loader-full v-if="isLoading" />
    <OrderPartial v-if="order_data" :order_data="order_data" />
  </div>
</template>

<script>
import ProductService from "@/services/v3/products/product.service";
import Paginacao from "@/components/cliente/base-components/Pagination";
import OrderPartial from "@/components/partials/_print_order.partial";
import StandardInput from "@/components/ui/inputs/StandardInput.vue";

export default {
  name: "productsModal",
  props: {
    close: {
      type: Function,
    },
    suplier: {
      type: Object,
    },
  },
  components: {
    ccPaginacao: Paginacao,
    OrderPartial,
    StandardInput,
  },
  data() {
    return {
      svc: new ProductService(),
      isLoading: true,
      orders: [],
      total: 0,
      current_order: null,
      order_data: null,
      selectStore: undefined,
      stores: [],
      products: [],
      page: 1,
      search: "",
      searchTimeout: null,
    };
  },
  mounted() {
    this.loadPage(1);
  },
  watch: {
    selectStore() {
      this.loadPage(1);
    },
  },
  methods: {
    loadPage(page) {
      this.isLoading = true;
      this.page = page;
      this.svc.get_products(this.suplier.id, page, this.search?.trim() || null)
        .then((resp) => {
          const rows = resp.data.data || [];

          this.products = rows.map((v) => ({
            text: v.pro_descricao,
            value: v,
          }));

          this.total = resp.data.total || 0;
        })
        .catch((err) => {
          console.error("Erro ao carregar produtos:", err);
          this.products = [];
          this.total = 0;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    sendPage(name, data) {
      const isWebView = this.isRunningInWebView();
      if (isWebView) {
        if (name == "subrequest") {
          this.$router.push({
            name,
            params: {
              return_to: "monitors-page",
              id: data.id_cotacao,
              seller_id: data.usu_id,
              store_id: data.id_loja,
              tab: "pedidos",
              provider_id: data.for_id,
            },
          });
        } else {
          this.$router.push({
            name,
            params: {
              backRouteName: "monitors-page",
              id: data.id_cotacao,
              sellerid: data.usu_id,

              sid: data.id_loja,
              providerid: data.for_id,
            },
            query: { backRoute: 2 },
          });
        }
      } else {
        if (name == "subrequest") {
          const routeData = this.$router.resolve({
            name,
            params: {
              return_to: "monitors-page",
              id: data.id_cotacao,
              seller_id: data.usu_id,
              store_id: data.id_loja,
              tab: "pedidos",
              provider_id: data.for_id,
            },
          });
          window.open(routeData.href, "_blank");
        } else {
          const routeData = this.$router.resolve({
            name,
            params: {
              backRouteName: "monitors-page",
              id: data.id_cotacao,
              sellerid: data.usu_id,
              sid: data.id_loja,
              providerid: data.for_id,
            },
            query: { backRoute: 2 },
          });
          window.open(routeData.href, "_blank");
        }
      }
    },
    isRunningInWebView() {
      const isIOSWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
        navigator.userAgent
      );

      const isAndroidWebView =
        /; wv\).*Chrome\//.test(navigator.userAgent) ||
        /Android.*Version\/\d\.\d\s/.test(navigator.userAgent);

      const isWebView =
        isIOSWebView ||
        isAndroidWebView ||
        navigator.userAgent.includes("WebView") ||
        window.hasOwnProperty("flutter_inappwebview") ||
        (window.hasOwnProperty("webkit") && window.webkit.messageHandlers);

      return isWebView;
    },

    print(order) {
      this.current_order = order;
      const [id_pedido, id_cotacao, id_loja, usu_id] = [
        [order.id_pedido],
        [order.id_cotacao],
        [order.id_loja],
        [order.usu_id],
      ];
      const dados = {
        id_pedido: id_pedido,
        id_cotacao: id_cotacao,
        id_loja: id_loja,
        usu_id: usu_id,
      };
      this.svc
        .get_order_data(dados)
        .then((response) => response.data)
        .then((data) => {
          this.order_data = data.data;
          console.log("print order", order);
          Vue.nextTick(() => {
            const originalTitle = document.title;
            window.document.title = `pedido-${order.id_pedido}.pdf`;

            try {
              this.$htmlToPaper("print-order", { name: "pedido.pdf" }, () => {
                this.current_order = null;
                this.order_data = null;
                window.document.title = originalTitle;
              });
            } catch (error) {
              console.warn("Impressão não suportada, usando fallback de download:", err);
              document.getElementById("print-order");
              if (!element) return;

              const blob = new Blob([element.outerHTML], { type: "application/pdf" });
              const url = window.URL.createObjectURL(blob);

              const link = document.createElement("a");
              link.href = url;
              link.download = `pedido-${order.id_pedido}.pdf`;
              document.body.appendChild(link);
              link.click();

              setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
              }, 100);

              this.current_order = null;
              this.order_data = null;
              document.title = originalTitle;
            }
          });
        })
        .catch((err) => {
          console.error("Erro ao buscar dados do pedido:", err);
        });
    },
    getSpecialBackground(index) {
      if (index % 2 != 0) return "page-table-line-special";
    },
    getDate(date) {
      if (date) {
        return moment(String(date)).format("DD/MM/YYYY");
      } else {
        return "--";
      }
    },
    export_products_report() {
      this.svc.export_products_report(this.suplier.id, this.search?.trim() || null)
      .then(response => response.data)
      .then(data => {
        var file = new Blob([data], {type: 'application/vnd.ms-excel'});
        var fileURL = URL.createObjectURL(file);
        var el = document.getElementById("download-excel");
        el.download = "Produtos-" + this.suplier.name + ".xls";
        el.href = fileURL;
        el.click();
        setTimeout(function(){
          window.URL.revokeObjectURL(fileURL);
        }, 100);
      })
      .catch(error => {
        console.log("Erro na geração do Excel: " . error);
      });
    },
    onSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.loadPage(1);
      }, 400);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 4;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
  font-size: 1vw;
}

.modal-content-container {
  background-color: white;
  width: 100vw;
  border-radius: 12px;
}

.mobile-list__header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-radius: 10px 10px 0px 0px;
  background-color: var(--primary-color);
}

.mobile-list__header-title {
  color: #ffffff;
  font-weight: 500;
  font-size: 2.5em;
}

.mobile-list__closebtn-icon {
  color: #ffffff;
  font-size: 30px;
  cursor: pointer;
}

.page-table-line-special {
  background: #f7f7f7;
}

.order-page-table-header {
  margin-top: 4vh;
  background: #fffefc;
  border: 0.5px solid #e5e5e5;
  font-weight: 600;
  font-size: 1.19em;
  color: #605f5f;
  padding: 0.7vh 0;
  display: flex;
  align-items: center;
  margin-bottom: 2vh;
}

.checkbox-width {
  width: 3.5%;
  text-align: center;
  color: var(--primary-color);
  cursor: pointer;
}

.id-width {
  width: 10%;
  text-align: center;
}

.description-width {
  width: 30%;
  text-align: center;
  padding: 0 0.5%;
}
.brand-width {
  width: 10%;
  text-align: center;
}
.date-width {
  width: 9%;
  text-align: center;
}

.price-width {
  width: 7%;
  text-align: center;
}

.embalagem-width {
  width: 10%;
  text-align: center;
}

.value-width {
  width: 15%;
  text-align: center;
}

.status-width {
  width: 7%;
  text-align: center;
}

.confirmationdate-width {
  width: 14%;
  text-align: center;
}

.confirmationdate-header-text {
  font-size: 0.8em;
}

.suplier-width {
  width: 14%;
  text-align: center;
}

.review-width {
  width: 8%;
  text-align: center;
}

.actions-width {
  width: 7%;
}

.page-filters__right-wrapper {
  width: 25vw;
}

.page-filters__right-title-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 1.2em;
}

.body-modal {
  height: 90vh;
  padding: 2vw;
  overflow: auto
}

.order-page-table {
  display: flex;
  font-weight: 300;
  font-size: 1em;
  color: #605f5f;
  align-items: center;
  padding: 2vh 0;
}

.order-page-table-separator {
  border-right: 0.5px solid #dde5e9;
}

.order-page-filter-section1 {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.selected-options-containear {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  column-gap: 1.5vw;
  min-height: 7vh;
}
.table-size {
  height: 68vh;
  overflow: auto;
}
.tablet {
  display: none;
}
.mobile {
  display: none;
}
.modal-actions-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.page-filter-search input {
  height: fit-content;
}

.excel-btn {
  width: auto !important;
  flex: 0 0 auto !important;   /* impede de esticar */
  display: inline-flex !important;  /* para caber no conteúdo */
}

.align-start{
  text-align: start;
}

@media only screen and (max-width: 800px) {
  .order-page-filter-container {
    flex-direction: column;
  }
  .modal-mask {
    font-size: 2vw;
  }
  .modal-content-container {
    width: 115vw;
  }
  .body-modal {
    height: 100vh;
  }
  .table-size {
    height: 80vh;
    margin-top: 2vh;
  }
  .desktop {
    display: none !important;
  }
  .tablet {
    display: block;
  }
  .order-page-filter-section1 {
    margin-bottom: 2vh;
  }
  .order-page-container {
    font-size: 1.25vw;
  }
  .order-page-filter-section1 {
    margin-bottom: 0;
  }

  .tablet {
    display: none;
  }
  .mobile {
    display: block;
  }
  .order-page-filter-section2 {
    width: 100%;
    display: flex;
  }
  .page-filters__right-title-wrapper {
    margin-top: 1vh;
  }
  .order-page-filter-section1 {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .mobile-table-row {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
  .mobile-expand-icon {
    font-size: 1.5em;
    color: var(--primary-color);
  }

  .width-icons-mobile {
    font-size: 2.2em;
  }
  .order-page-info-containear {
    flex-direction: column;
    align-items: flex-start;
  }
  .order-page-print-button {
    width: 40%;
    margin-top: 2vh;
  }
  .order-page-container {
    font-size: 2vw;
  }
  .order-page-table-header {
    display: none;
  }
  .order-page-table {
    flex-direction: column;
    gap: 1vh;
    margin-bottom: 3vh;
    font-size: 1.5em;
  }
  .order-page-table-separator {
    border-right: none;
    width: 100%;
    flex: unset;
    display: flex;
    justify-content: space-between;
    padding-right: 3vw;
  }
  .order-table-mobile-header {
    display: flex;
    font-weight: 700;
    font-size: 1.1em;
    text-align: inherit;
  }
  .hide-mobile-filters {
    display: none;
  }
  .order-table-seller-content {
    text-align: end;
  }
  .actions-width {
    display: flex;
    width: 100%;

    gap: 2vw;
    padding-right: 3vw;
  }
  .checkbox-width {
    color: unset;
    justify-content: flex-start;
    gap: 3vw;
    font-size: 1.1em;
    align-items: center;
  }
  .mobile-id-row {
    display: flex;
    align-items: center;
    gap: 1.5vw;
  }
  .page-filters__right-wrapper {
    width: 100%;
  }
  .mobile-filter-button {
    display: flex;
  }
  .mobile-buttons-row {
    display: flex;
    gap: 10%;
    margin-top: 2vh;
    width: 100%;
    justify-content: space-between;
  }
}
@media only screen and (max-width: 500px) {
  .order-page-container {
    font-size: 3vw;
  }
  .modal-content-container {
    max-width: 110vw;
    margin: 0 auto;
  }
}
@media only screen and (max-width: 200px) {
  .order-page-container {
    font-size: 3.25vw;
  }
}

@supports (-webkit-touch-callout: none) {
  .modal-content-container {
    width: 90vw;
    max-height: 85vh;
  }

  .table-size {
    height: 55vh;
  }

  .body-modal {
    padding: 12px;
  }
}
</style>
